import {
  type PropsWithChildren,
  type ReactElement,
} from 'react';
import styled from 'styled-components';
import type { TypographyVariantType } from '@n3/css-base';

import type {
  TypographyComponent,
  TypographyComponentProps,
  TypographyAlign,
} from './types';

export type TypographyProps<Props extends TypographyComponentProps> = PropsWithChildren<{
  /**
   * Дополнительный класс
   */
  className?: string;
  /**
   * Вариант текста
   */
  variant?: TypographyVariantType;
  /**
   * Цвет текста
   */
  color?: string;
  /**
   * Выравнивание в блоке
   */
  align?: TypographyAlign;
  /**
   * Компонент
   */
  component?: TypographyComponent<Props>;
}>;

export const StyledText = styled.p<{
  $align: TypographyAlign;
  $variant: TypographyVariantType;
  $color?: string;
}>(({
  $variant, $align, $color, theme: { typography, colors },
}) => ({
  ...typography.VARIANTS[$variant],
  color: $color || colors.TEXT_PRIMARY,
  textAlign: $align,
  margin: 0,
  padding: 0,
}));

export function Typography<Props extends TypographyComponentProps>({
  component = 'p',
  className = '',
  align = 'inherit',
  variant = 'body01',
  color = undefined,
  children = undefined,
  ...rest
}: TypographyProps<Props>): ReactElement {
  return (
    <StyledText
      className={className}
      as={component}
      $align={align}
      $color={color}
      $variant={variant}
      {...rest}
    >
      {children}
    </StyledText>
  );
}
